// warehouse.ts — resolusi gudang asal (origin) untuk halaman publik.
//
// KENAPA RPC PUBLIK: `brand_settings` SELECT-nya RLS hanya untuk authenticated
// Admin/Super Admin, jadi pengunjung anon SELALU dapat [] (insiden 2026-10-23:
// form tampil "Gudang asal belum dikonfigurasi" walau gudang ada di Pengaturan
// Merek). RPC `get_public_brand_info_by_id` (SECURITY DEFINER) sudah dipakai
// footer publik dan mengembalikan `warehouses` — pakai itu dulu, cache admin
// hanya fallback.
import { getCachedBrandSettings } from '../../../../utils/cacheHelpers/brands';
import { getPublicBrandRow } from '../../../../utils/publicBrandRow';
import { pickOriginWarehouse } from './pickWarehouse';

export { pickOriginWarehouse };
export type { PublicWarehouse } from './pickWarehouse';

async function fetchPublicWarehouses(brandId: string): Promise<unknown[]> {
    try {
        // RPC bersama dengan BrandFooter (utils/publicBrandRow, memo 120 dtk) —
        // footer + gudang jalan berbarengan saat form dibuka, cukup 1 roundtrip.
        const row: any = await getPublicBrandRow(brandId);
        if (row && Array.isArray(row?.warehouses) && row.warehouses.length) return row.warehouses;
    } catch { /* fallback di bawah */ }
    try {
        const { data } = await getCachedBrandSettings(brandId);
        const list = (data as any)?.warehouses;
        return Array.isArray(list) ? list : [];
    } catch { return []; }
}

export async function loadBrandWarehouse(
    brandId: string,
    everproSettings?: { warehouseId?: string; originSubDistrictName?: string } | null
) {
    if (!brandId) return null;
    const wh = pickOriginWarehouse(await fetchPublicWarehouses(brandId), everproSettings?.warehouseId);
    if (!wh?.postalCode) return null;
    return {
        originPostalCode: wh.postalCode,
        originSubDistrictName: wh.subDistrict || everproSettings?.originSubDistrictName || '',
    };
}
